@import "./shared.css";

:host {
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: var(--smoothly-font-weight);
	background-color: rgb(var(--smoothly-input-background));
	color: rgb(var(--smoothly-input-foreground));
}

:host[hidden] {
	display: none;
}

:host>.smoothly-input-container {
	position: relative;
	flex-grow: 1;
	height: 100%;
}

:host>.smoothly-input-container>label {
	left: var(--input-padding-side);
}

:host:not([show-label])>div>input {
	padding: 0 var(--input-padding-side);
}

:host>.smoothly-input-container>div.guide {
	position: absolute;
  box-sizing: border-box;
  align-content: center;
	height: 100%;
	padding-inline: var(--input-padding-side);
}
:host([show-label])>.smoothly-input-container>div.guide {
	padding-block: var(--input-value-padding-top) var(--input-value-padding-bottom);
}
:host>.smoothly-input-container>div.guide>div.value {
	display: inline;
	pointer-events: none;
	opacity: 0;
}
:host>.smoothly-input-container>div.guide>div.remainder {
	display: inline;
	pointer-events: none;
	opacity: 0.5;
}

:host>.smoothly-input-container>input {
	padding: 
		var(--input-value-padding-top) 
		var(--input-padding-side) 
		var(--input-value-padding-bottom) 
		var(--input-padding-side);
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	border: 0;
	z-index: 1;
	position: relative;
	font-size: 1rem;
	font-family: var(--smoothly-font-family);
}
:host([disabled])>.smoothly-input-container>input {
	cursor: not-allowed;
}

:host>.smoothly-invalid {
	display: none;
	z-index: 2;
	padding: 0.5rem;
}
:host[invalid]>.smoothly-invalid {
	display: flex;
}

:host>div>label {
	z-index: 1;
	pointer-events: none;
}

:host>div>input:focus {
	outline: none;
}

:host>div>input:-webkit-autofill,
:host>div>input:-webkit-autofill:hover,
:host>div>input:-webkit-autofill:focus,
:host>div>input:-webkit-autofill:active {
	box-shadow: 0 0 0 40em rgb(var(--smoothly-input-background)) inset;
	-webkit-box-shadow: 0 0 0 40em rgb(var(--smoothly-input-background)) inset;
}

:host>div>input:-webkit-autofill,
:host>div>input:-webkit-autofill+label {
	-webkit-text-fill-color: rgb(var(--smoothly-input-foreground));
}
:host>span.copyable {
	position: relative;
}
:host>span.copyable>smoothly-icon {
	cursor: pointer;
	display: flex;
	align-items: center;
	padding: 0.5rem;

}
:host>span.copyable:hover small,
:host>span.copyable:focus small {
	display: block;
}
:host>span.copyable>small {
	display: none;
	width: max-content;
	border-radius: 0.25rem;
	padding: 0.2rem 0.3rem;
	position: absolute;
	right: -0.5rem;
	top: -2rem;
	background-color: rgb(var(--smoothly-default-contrast));
	color: rgb(var(--smoothly-default-tint));
}
